import React from 'react';
import { Header1Text } from 'ui-toolkit';
import { useSetOrderNavigationTab } from '../../utilities/hooks/useSetOrderNavigationTab';
import { OrderTabs } from '../../store/order/orderNavigation/orderNavigationSlice';
import { Card } from '@zillow/constellation';
import { MessagingApp } from 'components/messaging/MessagingApp';
import { Inbox } from 'components/messaging/Inbox';
import { css } from '@/styled-system/css';

export const InboxPage: React.FC = () => {
  useSetOrderNavigationTab({ tab: OrderTabs.Inbox });
  return (
    <Card>
      <Header1Text>Inbox</Header1Text>
      <div className={css({ marginTop: '14px' })}>
        <MessagingApp>
          <Inbox />
        </MessagingApp>
      </div>
    </Card>
  );
};
